const extractResponseValue = (target, response, configurations) => {
  // if option is not active anymore, it won't appear amongst the current configurations and thus must be skipped
  const isOptionActive = (o) => !!o && !!configurations.find((c) => c.id === o.id);

  if (target === 'system') {
    return isOptionActive(response?.option)
      ? response.option.system_id
      : null;
  }
  if (['primers', 'reti', 'rasanti'].includes(target)) {
    if (!isOptionActive(response?.option))
      return null;
    const code = response.option.product?.art_cod;
    return !!code ? [code] : [];
  }
  return response?.value;
}

const retrieveKCCOptimizationResponses = (output, localResponses, context) => {
  if (output?.calculation?.length !== 1)
    throw Error('malformed output');

  const responses = localResponses || context?.responses;

  const obj = JSON.parse(output.calculation[0]);
  let responsesValuesObj = ["color", "system", "surface", "primers", "reti", "rasanti"].reduce(
    (prev, curr) => ({
      ...prev,
      [curr]: extractResponseValue(curr, responses[obj[`${curr}_question`]], context.configuration)
    }),
    {}
  );

  if (context?.survey?.id)
    responsesValuesObj['survey'] = context.survey.id;
  responsesValuesObj['is_tintometer'] = context?.service?.type === 'tintometer';

  return responsesValuesObj;
}

export default retrieveKCCOptimizationResponses;
